import types from './types'
export default {
  [types.SET_LOADING](state, isLoading) {
    state.loading = isLoading
  },
  setIsNavOpen(state, value) {
    state.isNavOpen = value
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value
  },
  [types.SET_TOGGLE_NAV](state) {
    state.isNavOpen = !state.isNavOpen
  },
}
